import { Interpolation } from "@emotion/core";
import { Border } from "../../../../design-tokens/borders";
import { DarkTheme } from "../../../../design-tokens/media-queries";

export const amazonStyles: Interpolation = {
  ".amzn-native-product": {
    borderRadius: Border.Radius,

    [DarkTheme]: {
      border: 0,
    },
  },
};
